module.exports = __webpack_public_path__ + "img/farrahicarpet-logo.ba592fd.svg";